import { IApplicationState } from '../../../../../types/types';
import { getAuthUser } from '../../../../../store/model/authUser/selectors/getAuthUser';

export const getCookieScopesFromUser = (state: IApplicationState) => {
    const user = getAuthUser(state);
    return user.allowedCookies;
};
